import { BenefitConfiguration } from "./benefit-configuration";

export class BenefitGroup {

    id: number = 0;
    description!: string;
    benefitConfigurations: BenefitConfiguration [] = [];

}